import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { sxButton, sxModal, sxOutlinedButton } from './sxProps';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { Button } from '@mui/material';
import './styles.css'
import { WarningModalProps } from '../../../interfaces/props/SaudeOnline/BiometriaFacial/WarningModalProps';

function WarningModal(props: WarningModalProps) {

    return (

          <div>
            <Modal
                open={props.open}
                onClose={props.handleCloseWarningModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={sxModal}>
                    <div className="camera-permition-feedback-modal-header">
                        <button className='camera-permition-modal-header-close' onClick={props.handleCloseWarningModal}>
                            <FontAwesomeIcon icon={faTimes} />
                        </button>
                    </div>
                    <h1 className="camera-permition-feedback-modal-title">
                        Leia antes de continuar
                    </h1>
                    <p className="camera-permition-feedback-modal-message">
                        Para sua segurança, este atendimento poderá ser auditado por não ter sido autenticado com biometria facial.
                        <br/>
                        Este procedimento se deve a nossas ações de prevenção a fraudes.
                    </p>
                    <div className="warning-modal-button-holder">
                        <Button 
                            variant="contained" 
                            onClick={props.handleContinueModal} 
                            sx={sxButton}
                            disabled={false}
                            fullWidth>
                                Continuar
                        </Button>

                        <div className="try-again-button">
                            <Button 
                                variant="outlined" 
                                onClick={props.handleTryAgain} 
                                sx={sxOutlinedButton}
                                disabled={false}
                                fullWidth>
                                    Tentar novamente
                            </Button>
                        </div>
                    </div>
                </Box>
            </Modal>
          </div>
      );
}

export default WarningModal;